import React, { ComponentProps, FC, memo } from 'react'
import Images from "./Images";
import DropImages from "../../../components/DropImages";

type ImagesPropsType = ComponentProps<typeof Images>;
type DropImagesPropsType = ComponentProps<typeof DropImages>;

interface ClarifyMediaProps {
  itemNamePrefix: ImagesPropsType['prefix'];
  videos: ImagesPropsType['images'];
  onSort: ImagesPropsType['sortCallback'];
  deletePendingVideos: ImagesPropsType['imagesToDelete'];
  onDeleteVideo: ImagesPropsType['setDeletedImages'];
  category: DropImagesPropsType['category'];
  droppedVideos: DropImagesPropsType['droppedImages'];
  onDroppedVideo: DropImagesPropsType['callback'];
}

export const ClarifyMedia: FC<ClarifyMediaProps> = memo(({
  itemNamePrefix,
  videos,
  onSort,
  deletePendingVideos,
  onDeleteVideo,
  category,
  droppedVideos,
  onDroppedVideo,
}) => {
  return (
    <div>
      <Images
        prefix={itemNamePrefix}
        images={videos}
        sortCallback={onSort}
        imagesToDelete={deletePendingVideos}
        setDeletedImages={onDeleteVideo}
      />
      <DropImages
        description={
          <div className='mt-2 d-flex justify-content-center p-2'>
            <ul className='text-left mb-0 rounded bg-dark p-4' style={{ listStyle: 'none' }}>
              <li>
                The preferable image sizes for having good pictures with high quality should be either:{' '}
                <b>480x345</b> or <b>750x562</b> (width-height) <br />
              </li>
              <li>
                The most important thing is to keep the ratio of width to a height equal to <b>1.3-1.5</b>{' '}
                <br />
              </li>
              <li>
                This means that the image can be bigger/smaller than the above sizes but the ratio must be kept
              </li>
            </ul>
          </div>
        }
        category={category}
        callback={onDroppedVideo}
        droppedImages={droppedVideos}
      />
    </div>
  )
})
